module.exports = __webpack_public_path__ + "img/totallymoney.34c6d878.png";